import React from "react";

const FAQ_GENERAL_QUESTIONS = [
  {
    title: "What is ByBlack?",
    body: (
      <>
        <p>
          ByBlack is a platform designed to provide Black-owned businesses with
          a way to reach new customers and access business resources. The
          platform was created and developed by the U.S. Black Chambers and is
          presented by American Express®. The platform offers a national
          Black-owned business directory and the only national certification
          currently available for Black-owned businesses.
        </p>
      </>
    ),
  },
  {
    title:
      "What business education and resources are offered for Black-owned businesses on ByBlack?",
    body: (
      <>
        <p>
          On ByBlack, Black-owned businesses can find a variety of resources
          including:
        </p>
        <ul>
          <li>
            Access to Educational Opportunities is available via the USBC or
            American Express.
          </li>
          <li>
            Grants & Potential Funding Programs – including access to
            information on when and where these programs are available.
          </li>
          <li>
            Local & National Relationship Building - When business owners join
            the ByBlack community, they receive priority invitations to join
            USBC affiliated local chambers of commerce in their community. They
            also have access to networking opportunities with other fellow
            business owners and experts through annual events.
          </li>
          <li>
            Corporate- Sponsored Matchmaking Opportunities- available via the
            USBC or American Express that can help connect buyers with
            suppliers.
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "Why are the USBC and Amex partnering around ByBlack?",
    body: (
      <>
        <p>
          ByBlack is part of both the USBC’s and American Express’ broader
          efforts to support Black-owned businesses.
        </p>
        <p>
          To learn more about the USBC’s and American Express's efforts to
          support Black-owned businesses visit{" "}
          <a
            href="https://usblackchambers.org/certification"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            https://usblackchambers.org/certification
          </a>
        </p>
      </>
    ),
  },
  {
    title: "How has ByBlack changed?",
    body: (
      <>
        <p>
          In June 2020, the U.S. Black Chambers, Inc. expanded the ByBlack
          platform, its national directory, to provide Black businesses with an
          avenue to register and promote their businesses.
        </p>
        <br />
        <p>
          In September 2021, with the support of American Express, the U.S.
          Black Chambers, Inc. further expanded ByBlack to establish the first
          national certification exclusively for Black-owned businesses offered
          with no application fee.
        </p>
        <br />
        <p>
          Black-owned businesses can now join the directory and/or get
          certified.
        </p>
      </>
    ),
  },
];

const FAQ_ONBOARDING_AND_DIRECTORY = [
  {
    title: "How do I onboard to the Black-owned business directory?",
    body: (
      <>
        <p>
          To onboard select “ONBOARD TO OUR DIRECTORY” on the main page at
          <a
            href="https://usblackchambers.org/certification"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            https://usblackchambers.org/certification
          </a>
          . Once you get into the platform, you can create a profile and submit
          your information, including your Business Name, Business Owner,
          Website, Phone Number, Address, Category, Business Description, NAICS,
          and Industry Code. Upon submission, you will go through a 2–5-day
          validation period where your information will get reviewed for
          accuracy and you will be notified via email when your business profile
          has been posted.
        </p>
        <br />
        <p>
          For questions about how to add your business to the ByBlack platform
          contact
          <a href={"mailto:programs@usblackchambers.org"}>
            {" "}
            programs@usblackchambers.org
          </a>
        </p>
      </>
    ),
  },
  {
    title: "Who can use the ByBlack directory platform?",
    body: (
      <>
        <p>
          Black-owned businesses can use this platform to create a profile and
          join the national business directory that’s easily searchable by
          customers and companies of all sizes. Once on the directory,
          Black-owned businesses can network with others within the community.
        </p>
        <br />
        <p>
          Customers and companies of all sizes can also use the ByBlack business
          directory to find Black-owned businesses they want to support.
        </p>
        <br />
        <p>
          For questions about how to add your business to the ByBlack directory
          contact
          <a href={"mailto:programs@usblackchambers.org"}>
            {" "}
            programs@usblackchambers.org
          </a>
        </p>
      </>
    ),
  },
];

const FAQ_CERTIFICATION_QUESTIONS = [
  {
    title: "Who is eligible to apply for certification?",
    body: (
      <>
        <p>
          To become certified as Black-owned, businesses must meet specific
          requirements including that the business: (i) be a majority (51% or
          more) owned, operated, and managed and controlled by a Black/African
          American person or persons who are either U.S. citizens or lawful
          permanent residents; (ii) exercise independence from any non-Black
          business enterprise; (iii) have its principal place of business
          (headquarters) located in the U.S.; and (iv) be an S-Corporation, C-
          Corporation, Partnership, LLC (single or multi-member) or a Sole
          Proprietorship formed as a legal entity in the U.S. and (v) be in
          business at least one year to meet tax documentation requirements
          based on the business structure.
        </p>
        <br />
        <p>
          To learn more about each of these requirements based on your business
          type, visit
          <a
            href="https://certification.byblack.us/documents/guide.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            https://certification.byblack.us/documents/guide.pdf
          </a>
          .
        </p>
      </>
    ),
  },
  {
    title: "What are the requirements to apply for certification?",
    body: (
      <>
        <p>
          The list of requirements to apply for certification varies by business
          structure. Visit
          <a
            href="https://certification.byblack.us/documents/guide.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            https://certification.byblack.us/documents/guide.pdf
          </a>{" "}
          to get requirements by structure.
        </p>
        <br />
      </>
    ),
  },
  {
    title: "How long does it take to get certified?",
    body: (
      <>
        <p>
          The application to get certified can be completed in as little as 30
          minutes once you have all the required documents available. For
          documentation requirements visit
          <a
            href="https://certification.byblack.us/documents/guide.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            https://certification.byblack.us/documents/guide.pdf
          </a>
          .
        </p>
        <br />
        <p>
          Applicants will then be required to complete a virtual site visit,
          which asks for information regarding business ownership, operation,
          and control that is complementary to the information presented in the
          certification application.
        </p>
        <br />
        <p>
          After you submit your completed application and virtual site visit,
          you will receive progress notifications in your dedicated user
          dashboard created when you apply or via email.
        </p>
        <br />
        <p>The certification process can take up to 30 days.</p>
        <br />
        <p>
          For questions about certification, you can contact{" "}
          <a href={"mailto:programs@usblackchambers.org"}>
            programs@usblackchambers.org
          </a>
          .
        </p>
      </>
    ),
  },
  {
    title:
      "Why is it important for Black-owned businesses to become certified?",
    body: (
      <>
        <p>
          ByBlack certification can help set a business apart in the marketplace
          and adds credibility when pursuing contracting opportunities with
          organizations that are looking to fulfill their commitments to spend
          with diverse suppliers.
        </p>
      </>
    ),
  },
];

export const FAQ_QUESTIONS = {
  GENERAL_QUESTIONS: FAQ_GENERAL_QUESTIONS,
  ONBOARDING_AND_DIRECTORY: FAQ_ONBOARDING_AND_DIRECTORY,
  CERTIFICATION_QUESTIONS: FAQ_CERTIFICATION_QUESTIONS,
};

function Collapsible({ faqQuestions }) {
  return (
    <div className="faq-wrapper">
      {faqQuestions?.map((question, indx) => {
        return (
          <div className="expandable">
            <div className="card">
              <div className="expandable-title">
                <h6 className="expandable-heading h6-small">
                  {question.title}
                </h6>
                <img
                  src="/assets/images/landing-page/icon-caret-right_1.svg"
                  alt=""
                  className="expandable-icon"
                />
              </div>
              <div className="expandable-content-wrapper">
                <div className="expandable-content">{question.body}</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Collapsible;
